import { Composition } from '@/pages/calibration/composition'
import axios, { AxiosResponse } from 'axios'
import { Ba, DeviceRoles, ResistanceBox } from '@/pages/calibration/calibration'
import { samApiClient } from '@/api/index'
import { apiErrorMessage } from '@/api/Util'
export const getDeviceComposition = async (
  uid: string,
  country: string,
): Promise<AxiosResponse<Composition>> => {
  try {
    const params = new URLSearchParams()
    params.set('country', country)
    return await samApiClient.get<Composition>(
      `device/${uid}/composition?${params.toString()}`,
    )
  } catch (error) {
    if (!axios.isCancel(error)) throw error
    throw error
  }
}

export const getDeviceRoles = async (
  deviceType: string,
): Promise<AxiosResponse<DeviceRoles>> => {
  try {
    const params = new URLSearchParams()
    params.set('deviceType', deviceType)
    return await samApiClient.get<DeviceRoles>(`roles?${params.toString()}`)
  } catch (error) {
    if (!axios.isCancel(error)) throw error
    throw error
  }
}

export const getRssCalibration = async (
  uid: string,
): Promise<AxiosResponse<{ resistances: ResistanceBox[] }>> => {
  try {
    return await samApiClient.get<{ resistances: ResistanceBox[] }>(
      `rss/${uid}/calibration`,
    )
  } catch (error) {
    if (!axios.isCancel(error)) throw error
    throw error
  }
}

export const getZklRcCalibration = async (
  uid: string,
): Promise<
  AxiosResponse<{
    resistances: ResistanceBox[]
    jumpers: string[]
    calibration: { ba: Ba; frequency: number }
  }>
> => {
  try {
    return await samApiClient.get(`zkl-rc/${uid}/calibration`)
  } catch (error) {
    if (!axios.isCancel(error)) throw error
    throw error
  }
}

export const updateServiceInterval = async (
  uid: string,
  years: number,
): Promise<AxiosResponse<void>> => {
  try {
    return await samApiClient.patch<void>(`device/${uid}/service-interval`, {
      years,
    })
  } catch (error) {
    if (!axios.isCancel(error)) throw error
    throw error
  }
}

// Trigger only: the backend derives the role-based configuration set from
// the device, applies it and verifies it against the device via RPC.
export const setRssConfiguration = async (
  uid: string,
): Promise<AxiosResponse<void>> => {
  try {
    return await samApiClient.patch<void>(`rss/${uid}/measurement-config`)
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Surface the backend's reason - the device or gateway explains why the
      // configuration could not be applied, which is what the engineer needs.
      const reason = apiErrorMessage(error)
      if (reason) throw new Error(reason)
    }
    throw error
  }
}
export const postDeviceComposition = async (
  uid: string,
  configurationId: number,
): Promise<AxiosResponse<void>> => {
  try {
    return await samApiClient.post<void>(`device/${uid}/composition`, {
      configuration: configurationId,
    })
  } catch (error) {
    if (!axios.isCancel(error)) throw error
    throw error
  }
}

export const updateMustHaveAftc = async (
  uid: string,
  mustHaveAftc: boolean,
): Promise<AxiosResponse<void>> => {
  try {
    return await samApiClient.patch<void>(`zkl-rc/${uid}/aftc`, {
      mustHaveAftc,
    })
  } catch (error) {
    if (!axios.isCancel(error)) throw error
    throw error
  }
}
